import React, { useState, useCallback } from 'react';
import { Check, ChevronsUpDown } from 'lucide-react';
import { cn } from '../../lib/utils';
import { Button } from './button';
import {
  Command,
  CommandInput,
  CommandEmpty,
  CommandGroup,
  CommandItem,
} from './command';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from './popover';

const CategoryDropdown = ({ value, onChange, placeholder = "Select category...", categories = [], loading = false, hasMore = false, onLoadMore, error }) => {
  const [open, setOpen] = useState(false);

  const handleScroll = useCallback((e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (scrollTop + clientHeight >= scrollHeight - 10 && hasMore && !loading && onLoadMore) {
      onLoadMore();
    }
  }, [hasMore, loading, onLoadMore]);


  const selectedCategory = categories.find(cat => cat.categoryId === value);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          role="combobox"
          aria-expanded={open}
          className={cn(
            "w-full justify-between",
            error && "border-rose-500 ring-rose-500 bg-rose-50"
          )}
        >
          {selectedCategory ? selectedCategory.categoryName : placeholder}
          <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[var(--radix-popover-trigger-width)] p-0" align="start">
        <Command>
          <CommandInput placeholder="Search category..." />
          <div onScroll={handleScroll} onWheel={(e) => e.stopPropagation()} className="max-h-[300px] overflow-y-auto touch-pan-y">
            <CommandEmpty>No categories found.</CommandEmpty>
            <CommandGroup>
              {categories.map((category) => (
                <CommandItem
                  key={category.categoryId}
                  value={category.categoryName}
                  onSelect={() => {
                    onChange(category.categoryId, category.categoryName);
                    setOpen(false);
                  }}
                >
                  <Check
                    className={cn(
                      "mr-2 h-4 w-4",
                      value === category.categoryId ? "opacity-100" : "opacity-0"
                    )}
                  />
                  {category.categoryName}
                </CommandItem>
              ))}
              {loading && (
                <CommandItem disabled>
                  Loading more...
                </CommandItem>
              )}
            </CommandGroup>
          </div>
        </Command>
      </PopoverContent>
    </Popover>
  );
};

export default CategoryDropdown;